import { Alert } from './Alert'
import { Avatar } from './Avatar'
import { Badge } from './Badge'
import { Button } from './Button'
import { cardTheme } from './Card'
import { Checkbox } from './Checkbox'
import { Container } from './Container'
import { Footer } from './Footer'
import { Form } from './Form'
import { FormError } from './FormError'
import { FormGroup } from './FormGroup'
import { FormLabel } from './FormLabel'
import { Heading } from './Heading'
import { Input } from './Input'
import { Link } from './Link'
import { menuTheme } from './Menu'
import { MenuItem } from './MenuItem'
import { NumberInput } from './NumberInput'
import { Popover } from './Popover'
import { Radio } from './Radio'
import { Section } from './Section'
import { Select } from './Select'
import { sliderTheme } from './Slider'
import { Spinner } from './Spinner'
import { switchTheme } from './Switch'
import { Table } from './Table'
import { tabsTheme } from './Tabs'
import { Text } from './Text'
import { Textarea } from './Textarea'
import { Tooltip } from './Tooltip'

export const components = {
  Alert,
  Avatar,
  Badge,
  Button,
  Card: cardTheme,
  Checkbox,
  Container,
  Footer,
  Form,
  FormError,
  FormGroup,
  FormLabel,
  Heading,
  Input,
  Menu: menuTheme,
  MenuItem,
  NumberInput,
  Link,
  Popover,
  Radio,
  Section,
  Select,
  Slider: sliderTheme,
  Spinner,
  Switch: switchTheme,
  Table,
  Tabs: tabsTheme,
  Text,
  Textarea,
  Tooltip,
}
